var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.form.valid),callback:function ($$v) {_vm.$set(_vm.form, "valid", $$v)},expression:"form.valid"}},[_vm._t("default",null,{"rules":_vm.rules,"form":_vm.form,"inputColor":_vm.inputColor,"canEdit":_vm.canEdit,"update":_vm.update})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }